import { Fade, Snackbar, useMediaQuery } from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import React from 'react';
import classes from './index.module.scss';

export interface CustomSnackbarProps {
  type: 'info' | 'success' | 'error' | 'warning';
  message: string;
  messageType?: 'string' | 'html';
  open: boolean;
  autoHideDuration?: number | null;
  onClose: () => void;
  allowClose?: boolean;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CustomSnackbar = ({
  autoHideDuration = 2000,
  type,
  message,
  messageType = 'string',
  open,
  onClose,
  allowClose = true,
}: CustomSnackbarProps) => {
  const isMobile = useMediaQuery('(max-width:37.5em)');

  return (
    <>
      {allowClose ? (
        <Snackbar
          TransitionComponent={Fade}
          open={open}
          autoHideDuration={autoHideDuration}
          classes={{ root: classes.root }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          onClose={onClose}
        >
          <Alert onClose={onClose} severity={type}>
            {messageType === 'string' ? (
              message
            ) : (
              <div dangerouslySetInnerHTML={{ __html: message }}></div>
            )}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          TransitionComponent={Fade}
          open={open}
          autoHideDuration={autoHideDuration}
          classes={{ root: classes.root }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert severity={type}>
            {messageType === 'string' ? (
              message
            ) : (
              <div dangerouslySetInnerHTML={{ __html: message }}></div>
            )}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default CustomSnackbar;
